<template>
  <v-app id="inspire" class="grey lighten-3">
   <Navbar/>
   <v-main>
     <v-flex>
         <v-container
        fluid
      >
        <v-layout px-5  row class="mt-1">
          <v-flex xs6 md9 dense>
            <div class="subtitle" style=" font-size: 0.92em;">Dashboard</div>
          </v-flex>
          <v-flex class="text-right" xs6 md3 >
            <v-spacer/>
             <v-breadcrumbs class="pa-0" :items="crumbItems" id="crumbs">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" @click="breadCrumbClick(item)" style=" font-size: 0.92em;">
                  {{item.text}}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
        <Header/>
        <EditPassword/>
      </v-container>
     </v-flex>
   </v-main>
  </v-app>
</template>

<script>
import Navbar from '@/components/NavbarComponent'
import Header from '@/components/HeaderComponent'
import EditPassword from '@/components/EditPassword'

export default {
  data: () => {
    return {
      crumbItems: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '#',
          route: '/home'
        },
        {
          text: 'Edit Profile',
          disabled: false,
          href: '#',
          route: '/editProfile'
        },
        {
          text: 'Edit Password',
          disabled: false,
          href: '#',
          route: '/editPassword'
        }
      ]
    }
  },
  components: {
    Navbar,
    Header,
    EditPassword
  },
  mounted: [
  ],
  methods: {
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
#crumbs{
  align-content: right;
  justify-content: right;
}
</style>
